import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const Register = ({ open, email }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailValue, setEmailValue] = useState(email || "");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [interests, setInterests] = useState({
    buyingHouses: false,
    sellingHouses: false,
    investing: false,
    realEstateAgent: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    setEmailValue(email || "");
  }, [email]);

  const handleInterestChange = (event) => {
    const { name, checked } = event.target;
    setInterests((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== verifyPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const payload = {
        email: emailValue,
        password,
        firstName,
        lastName,
        preferredLanguage: "en",
        membershipTier: "pro",
        role: "user",
        lastLogin: new Date().toISOString(), // Optional, could be null
        // Optional: Include interests if your schema supports it
        // interests: JSON.stringify(interests),
      };

      const response = await axios.post(
        "https://bb9i166nwl.execute-api.us-east-2.amazonaws.com/createUser",
        payload
      );

      console.log("User created:", response.data);
      navigate("/pricing");
    } catch (error) {
      alert("Error creating user: " + error.message);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
          mx: "auto",
          mt: 8,
          p: 3,
          boxShadow: 3,
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Almost there. Just tell us a little more about yourself.
        </Typography>

        <TextField
          fullWidth
          required
          label="Email"
          margin="normal"
          value={emailValue}
          onChange={(e) => setEmailValue(e.target.value)}
        />

        <TextField
          fullWidth
          required
          label="First Name"
          margin="normal"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />

        <TextField
          fullWidth
          required
          label="Last Name"
          margin="normal"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />

        <TextField
          fullWidth
          label="Phone Number"
          margin="normal"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <TextField
          fullWidth
          required
          label="Password"
          type="password"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <TextField
          fullWidth
          required
          label="Verify Password"
          type="password"
          margin="normal"
          value={verifyPassword}
          onChange={(e) => setVerifyPassword(e.target.value)}
        />
      </Box>

      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={interests.sellingHouses}
              onChange={handleInterestChange}
              name="sellingHouses"
            />
          }
          label="I'm interested in selling my house"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={interests.investing}
              onChange={handleInterestChange}
              name="investing"
            />
          }
          label="I'm interested in investing in real estate"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={interests.realEstateAgent}
              onChange={handleInterestChange}
              name="realEstateAgent"
            />
          }
          label="I am a Real Estate Agent"
        />

        <Button
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          onClick={handleSubmit}
        >
          Register
        </Button>
      </Box>
    </>
  );
};

export default Register;

